module.exports = __webpack_public_path__ + "static/mb_thumbnail-89f42de38b32a5ce177f2b300ae076bc.jpg";